export default "__VITE_ASSET__6EthvWVv__"